import React from 'react';
import './List.css';
import previewImage from '../../assets/img/offers/1.jpg';
import { services } from './list.json'
import { Link } from 'react-router-dom';

class OfferList extends React.Component {
  render() {
    return (
      <div className={'container'}>
        {services.map((offer, i) => {
          return (
            <Link to={`/oferta/${i}`} key={i} className={'offer-item'}>
              <div className={'offer-item-bg'} style={{backgroundImage: 'url(' + previewImage + ')'}}></div>
              <div className={'offer-title'}>{offer.title}</div>
            </Link>
          )
        })}
      </div>
    )
  }
}

export default OfferList;
